<template>
  <div class="hint">
    <div class="title">温馨提示</div>
  </div>
</template>

<script>
export default {
  name: 'hint'
}
</script>

<style lang="less" scope>

</style>


// WEBPACK FOOTER //
// src/components/youKu/hint.vue